// Redux Actions
export const GET_CALENDAR_REQUEST = 'api/GET_CALENDAR_REQUEST';
export const GET_CALENDAR_SUCCESS = 'api/GET_CALENDAR_SUCCESS';
export const GET_CALENDAR_ERROR = 'api/GET_CALENDAR_ERROR';

export const GET_DAY_CALENDAR_REQUEST = 'api/GET_DAY_CALENDAR_REQUEST';
export const GET_DAY_CALENDAR_SUCCESS = 'api/GET_DAY_CALENDAR_SUCCESS';
export const GET_DAY_CALENDAR_ERROR = 'api/GET_DAY_CALENDAR_ERROR';

export const GET_QUERY_PARAM_CALENDAR_REQUEST = 'api/GET_QUERY_PARAM_CALENDAR_REQUEST';
export const GET_QUERY_PARAM_CALENDAR_SUCCESS = 'api/GET_QUERY_PARAM_CALENDAR_SUCCESS';
export const GET_QUERY_PARAM_CALENDAR_ERROR = 'api/GET_QUERY_PARAM_CALENDAR_ERROR';

export const GET_CUP_TABBAR_REQUEST = 'api/GET_CUP_TABBAR_REQUEST';
export const GET_CUP_TABBAR_SUCCESS = 'api/GET_CUP_TABBAR_SUCCESS';
export const GET_CUP_TABBAR_ERROR = 'api/GET_CUP_TABBAR_ERROR';

export const GET_CUP_CALENDAR_REQUEST = 'api/GET_CUP_CALENDAR_REQUEST';
export const GET_CUP_CALENDAR_SUCCESS = 'api/GET_CUP_CALENDAR_SUCCESS';
export const GET_CUP_CALENDAR_ERROR = 'api/GET_CUP_CALENDAR_ERROR';

export const GET_CUP_DAY_CALENDAR_REQUEST = 'api/GET_CUP_DAY_CALENDAR_REQUEST';
export const GET_CUP_DAY_CALENDAR_SUCCESS = 'api/GET_CUP_DAY_CALENDAR_SUCCESS';
export const GET_CUP_DAY_CALENDAR_ERROR = 'api/GET_CUP_DAY_CALENDAR_ERROR';

export const GET_VOLLEY_DAY_CALENDAR_REQUEST = 'api/GET_VOLLEY_DAY_CALENDAR_REQUEST';
export const GET_VOLLEY_DAY_CALENDAR_SUCCESS = 'api/GET_VOLLEY_DAY_CALENDAR_SUCCESS';
export const GET_VOLLEY_DAY_CALENDAR_ERROR = 'api/GET_VOLLEY_DAY_CALENDAR_ERROR';

export const GET_MOTORSPORT_CALENDAR_REQUEST = 'api/GET_MOTORSPORT_CALENDAR_REQUEST';
export const GET_MOTORSPORT_CALENDAR_SUCCESS = 'api/GET_MOTORSPORT_CALENDAR_SUCCESS';
export const GET_MOTORSPORT_CALENDAR_ERROR = 'api/GET_MOTORSPORT_CALENDAR_ERROR';

export const GET_TENNIS_CALENDAR_REQUEST = 'api/GET_TENNIS_CALENDAR_REQUEST';
export const GET_TENNIS_CALENDAR_SUCCESS = 'api/GET_TENNIS_CALENDAR_SUCCESS';
export const GET_TENNIS_CALENDAR_ERROR = 'api/GET_TENNIS_CALENDAR_ERROR';

export const GET_VOLLEY_CALENDAR_REQUEST = 'api/GET_VOLLEY_CALENDAR_REQUEST';
export const GET_VOLLEY_CALENDAR_SUCCESS = 'api/GET_VOLLEY_CALENDAR_SUCCESS';
export const GET_VOLLEY_CALENDAR_ERROR = 'api/GET_VOLLEY_CALENDAR_ERROR';

export const GET_VOLLEY_TABBAR_REQUEST = 'api/GET_VOLLEY_TABBAR_REQUEST';
export const GET_VOLLEY_TABBAR_SUCCESS = 'api/GET_VOLLEY_TABBAR_SUCCESS';
export const GET_VOLLEY_TABBAR_ERROR = 'api/GET_VOLLEY_TABBAR_ERROR';

export const GET_RUGBY_TABBAR_REQUEST = 'api/GET_RUGBY_TABBAR_REQUEST';
export const GET_RUGBY_TABBAR_SUCCESS = 'api/GET_RUGBY_TABBAR_SUCCESS';
export const GET_RUGBY_TABBAR_ERROR = 'api/GET_RUGBY_TABBAR_ERROR';

export const GET_RUGBY_CALENDAR_REQUEST = 'api/GET_RUGBY_CALENDAR_REQUEST';
export const GET_RUGBY_CALENDAR_SUCCESS = 'api/GET_RUGBY_CALENDAR_SUCCESS';
export const GET_RUGBY_CALENDAR_ERROR = 'api/GET_RUGBY_CALENDAR_ERROR';

export const GET_BASKET_TABBAR_REQUEST = 'api/GET_BASKET_TABBAR_REQUEST';
export const GET_BASKET_TABBAR_SUCCESS = 'api/GET_BASKET_TABBAR_SUCCESS';
export const GET_BASKET_TABBAR_ERROR = 'api/GET_BASKET_TABBAR_ERROR';

export const GET_CYCLE_CALENDAR_REQUEST = 'api/GET_CYCLE_CALENDAR_REQUEST';
export const GET_CYCLE_CALENDAR_SUCCESS = 'api/GET_CYCLE_CALENDAR_SUCCESS';
export const GET_CYCLE_CALENDAR_ERROR = 'api/GET_CYCLE_CALENDAR_ERROR';

export const GET_NBA_CALENDAR_REQUEST = 'api/GET_NBA_CALENDAR_REQUEST';
export const GET_NBA_CALENDAR_SUCCESS = 'api/GET_NBA_CALENDAR_SUCCESS';
export const GET_NBA_CALENDAR_ERROR = 'api/GET_NBA_CALENDAR_ERROR';

export const GET_BASKET_CALENDAR_REQUEST = 'api/GET_BASKET_CALENDAR_REQUEST';
export const GET_BASKET_CALENDAR_SUCCESS = 'api/GET_BASKET_CALENDAR_SUCCESS';
export const GET_BASKET_CALENDAR_ERROR = 'api/GET_BASKET_CALENDAR_ERROR';

//Bet API
export const GET_BET_REQUEST = 'api/GET_BET_REQUEST';
export const GET_BET_SUCCESS = 'api/GET_BET_SUCCESS';
export const GET_BET_ERROR = 'api/GET_BET_ERROR';

export const SET_TENNIS_PHASE = 'calendar/SET_TENNIS_PHASE';

export const TOGGLE_HIGHLIGHTS = 'calendar/TOGGLE_HIGHLIGHTS';
export const SET_FAVOURITE_MATCH = 'calendar/SET_FAVOURITE_MATCH';

// Favourites
export const FAVOURITES_MATCH = 'favourites/FAVOURITES_MATCH';
export const UPDATE_FAVOURITES = 'favourites/UPDATE_FAVOURITES';
export const REMOVE_FAVOURITES_MATCH = 'favourites/REMOVE_FAVOURITES_MATCH';

export const GET_YESTERDAY_TOMORROW_REQUEST = 'favourites/GET_YESTERDAY_TOMORROW_REQUEST';
export const GET_YESTERDAY_TOMORROW__SUCCESS = 'favourites/GET_YESTERDAY_TOMORROW__SUCCESS';
export const GET_YESTERDAY_TOMORROW_ERROR = 'favourites/GET_YESTERDAY_TOMORROW_ERROR';

export const GET_TODAY_REQUEST = 'favourites/GET_TODAY_REQUEST';
export const GET_TODAY__SUCCESS = 'favourites/GET_YESTERDAY_TOMORROW__SUCCESS';
export const GET_TODAY_ERROR = 'favourites/GET_TODAY_ERROR';

export const SET_YESTERDAY_SPORT = 'favourites/SET_YESTERDAY_SPORT';
export const SET_TOMORROW_SPORT = 'favourites/SET_TOMORROW_SPORT';
export const SET_TODAY_SPORT = 'favourites/SET_TODAY_SPORT';


// Dictionary
export const INIT_DICTIONARY = 'dictionary/INIT_DICTIONARY';

// Tooltip
export const SHOW_TOOLTIP = 'tooltip/SHOW_TOOLTIP';
export const HIDE_TOOLTIP = 'tooltip/HIDE_TOOLTIP';

// Filter Bar
export const LIVE = 'LIVE';

//Local Storage
export const CLEAR_LOCAL_STORAGE = 'localStorage/CLEAR_LOCAL_STORAGE';
export const SET_LOCAL_STORAGE_DATE = 'locaStorage/SET_LOCAL_STORAGE_DATE';
export const REMOVE_FAVOURITES_MATCH_FROM_LOCALSTORAGE = 'localStorage/REMOVE_FAVOURITES_MATCH_FROM_LOCALSTORAGE';
export const UPDATE_LOCAL_STORAGE = 'localStorage/UPDATE_LOCAL_STORAGE';
export const INCREMENT_SESSION_COUNTER = 'localStorage/INCREMENT_SESSION_COUNTER';

//Local storage keys
export const PREFERRED_COUNTER = 'preferredCount';
export const PREFERRED_MATCH = 'preferredMatch';
export const PREFERRED_MAP = 'preferredMap';
export const SESSION_COUNTER = 'sessionCount';

// Table Types
export const TYPE_HUB = 'HUB';
export const TYPE_PREFERRED = 'PREFERRED';

// Timing Tag
export const PREMATCH = 'PreMatch';
export const FULLTIME = 'FullTime';
export const FULLTIME90 = 'FullTime90';
export const FULLTIMEPENS = 'FullTimePens';
export const SHOOTOUT = 'ShootOut';
export const ABANDONED = 'Abandoned';
export const POSTPONED = 'Postponed';
export const NOTPLAYED = 'Notplayed';
export const Notplayed = 'Notplayed';
export const DELAYED = 'Delayed';
export const CANCELED = 'Cancelled';
export const SUSPENDED = 'Suspended';
export const HALFTIME = 'HalfTime';
export const EXTRAHALFTIME = 'ExtraHalfTime';
export const FIRSTHALF = 'FirstHalf';
export const SECONDHALF = 'SecondHalf';
export const EXTRAFIRSTHALF = 'ExtraFirstHalf';
export const EXTRASECONDHALF = 'ExtraSecondHalf';
export const WALKOVER_TAG = 'Walkover';

// Match Status
export const PREMATCH_STATUS = 'PREMATCH';
export const POSTPONED_STATUS = 'POSTPONED';
export const NOTPLAYED_STATUS = 'NOTPLAYED';
export const CANCELLED_STATUS = 'CANCELLED';
export const LIVE_STATUS = 'LIVE';
export const FULL_STATUS = 'FULL';

// Race Status
export const NOTSTARTED = 'NOTSTARTED'; // and for cycle
export const ON_TRACK = 'ON TRACK';
export const FINISHED = 'FINISHED';
export const RED_FLAG = 'RED FLAG';
export const YELLOW_FLAG = 'YELLOW FLAG';
export const SAFETY_CAR = 'SAFETY CAR';
export const ABORTED = 'ABORTED';
export const CANCELLED = 'CANCELLED';
export const TOAPPROVAL = 'TOAPPROVAL';
export const TBD = 'TBD';

// Cycle Status
export const INPROGRESS = 'INPROGRESS';
export const COMPLETE = 'COMPLETE';

//Tennis Status
export const INPLAY = 'INPLAY';
export const BYE = 'BYE';
export const WALKOVER = 'WALKOVER';
export const RETIRED = 'RETIRED';
export const DEFAULTED = 'DEFAULTED';
export const WIN = 'WIN';
export const SUSPENDED_STATUS = 'SUSPENDED';

// Tennis competition type
export const MENS_SINGLES = 'Mens Singles';
export const WOMENS_SINGLES = 'Womens Singles';
export const COMPETITION_TYPE_MAN = 'Mens';
export const COMPETITION_TYPE_WOMAN = 'woman';
export const DAVIS_CUP = 'Davis Cup';
export const FED_CUP = 'Fed Cup';
export const COMPETITION_TYPE_DAVIS_CUP = 'davis-cup';
export const COMPETITION_TYPE_FED_CUP = 'fed-cup';

// Basket Status
export const FIXTURE = 'FIXTURE';
export const PLAYING = 'PLAYING';
export const PLAYED = 'PLAYED';

// Rugby Status
export const RESULT = 'RESULT';

// Basket periodId
export const PRE_GAME = '0';
export const FIRST_HALF_TIME = '1';
export const SECOND_HALF_TIME = '2';
export const FIRST_QUARTER = '3';
export const SECOND_QUARTER = '4';
export const THIRD_QUARTER = '5';
export const FOURTH_QUARTER = '6';
export const OVERTIME = '7';
export const FIRST_HALF_BREAK = '11';
export const HALF_TIME_BREAK = '12';
export const SECOND_HALF_BREAK = '13';
export const BEFORE_OVERTIME = '14';
export const POST_GAME = '15';



// WEBPACK FOOTER //
// ./src/constants/index.js